// extracted by mini-css-extract-plugin
module.exports = {"timeConfig":"style__timeConfig__+luuM"};